;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .constant('TRACE_NOTE_READ_ONLY_PROPERTY_TYPE', {
      READ_ONLY_STATUS: 'read.only.status',
      SEND_TRACE_BUGTRACKER: 'read.only.trace.bugtracker',
      TWO_WAY_INTEGRATION_STATUS: 'read.only.two.way.integration.status'
    })
})()
